(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lienne-autumn-banner"] && !Shopify.designMode) return;
  try {
    (()=>{function tick(){document.querySelectorAll('[data-autumn-end]').forEach(el=>{const t=Math.max(0,Math.floor((Date.parse(el.dataset.autumnEnd)-Date.now())/1000));el.hidden=t===0;el.querySelector('[data-autumn-clock]').textContent=[Math.floor(t/3600),Math.floor(t%3600/60),t%60].map(n=>String(n).padStart(2,'0')).join(':');});}tick();setInterval(tick,1000);document.addEventListener('shopify:section:load',tick);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nervea-article-offer"] && !Shopify.designMode) return;
  try {
    function initArticleOrders(){document.querySelectorAll('[data-nr-order]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const select=root.querySelector('select[name="id"]');if(!select)return;const cards=root.querySelectorAll('[data-pack].nr-pack');function sync(){const option=select.selectedOptions[0];cards.forEach(card=>card.setAttribute('aria-pressed',String(card.dataset.pack===option.dataset.pack)));}cards.forEach(card=>card.addEventListener('click',()=>{const size=select.selectedOptions[0].dataset.size;const options=Array.from(select.options);const option=options.find(o=>o.dataset.pack===card.dataset.pack&&o.dataset.size===size&&!o.disabled)||options.find(o=>o.dataset.pack===card.dataset.pack&&!o.disabled);if(option){select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));}}));select.addEventListener('change',sync);sync();});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initArticleOrders);else initArticleOrders();document.addEventListener('shopify:section:load',initArticleOrders);
  } catch(e) { console.error(e); }
})();

})();
